import { rolesQuery } from "@common/api/roles"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router"
import { DetailPanel } from "@/components/layout/detail-panel"
import useCustomToast from "@/hooks/use-custom-toast"
import { PanelHeading } from "@/routes/_layout/settings/_panel/-components/panel-heading"
import { RoleDetailsForm } from "@/routes/_layout/settings/_panel/workspace/roles/-components/form/role-details-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/roles/_list/$roleId",
)({
  staticData: { detailSidebar: true },
  component: RolePanel,
})

function RolePanel(): React.ReactElement {
  const { roleId } = Route.useParams()
  const { data } = useSuspenseQuery(rolesQuery())
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const role = data.data.find((item) => item.id === roleId)

  if (!role) {
    return <Outlet />
  }

  const close = () =>
    navigate({ to: "/settings/workspace/roles", search: true })

  return (
    <DetailPanel
      title={role.label}
      heading={
        <PanelHeading
          label={role.kind === "custom" ? "Custom role" : "Default role"}
        />
      }
      onClose={close}
    >
      <RoleDetailsForm
        key={`${role.id}:${role.updated_at}`}
        role={role}
        onSave={(saved) =>
          showToast("Saved", `${saved.name} updated.`, "success")
        }
      />
      <Outlet />
    </DetailPanel>
  )
}
